import classNames from "classnames";
import classes from "./classes.module.scss";
import Typography from "components/elements/Typography";
import { ChevronDownIcon } from "@heroicons/react/24/solid";
import { TMenuItem } from "..";
import { useCallback } from "react";
import { EProjectTab } from "components/pages/ProfessionalSpace/ProjectFormContext";

type IProps = {
	menuItem: TMenuItem;
	setCurrentTab: (tab: EProjectTab) => void;
	currentTab: EProjectTab;
};

export default function MenuItemWithSubtabs(props: IProps) {
	const onClick = useCallback(() => {
		const firstSubTab = props.menuItem.subTabs?.[0];
		if (!firstSubTab) return;
		props.setCurrentTab(firstSubTab.tab);
	}, [props]);

	const onSubTabClick = useCallback((tab: EProjectTab) => props.setCurrentTab(tab), [props]);

	const isCurrentTabOneOfSubTabs = props.menuItem.subTabs?.some((subTab) => subTab.tab === props.currentTab);

	return (
		<div className={classes["root"]}>
			<div className={classNames(classes["tab-content"], { [classes["active"]!]: props.currentTab === props.menuItem.tab })} onClick={onClick}>
				{props.menuItem.icon}
				<Typography type="p" size="medium" weight="regular" className={classes["label"]}>
					{props.menuItem.label}
				</Typography>
				<ChevronDownIcon className={classNames(classes["chevron"], { [classes["active"]!]: isCurrentTabOneOfSubTabs })} />
			</div>

			{isCurrentTabOneOfSubTabs && (
				<div className={classes["subtabs-container"]}>
					{props.menuItem.subTabs?.map((subTab) => (
						<span key={subTab.tab} onClick={() => onSubTabClick(subTab.tab)}>
							<Typography
								type="p"
								size="medium"
								weight="regular"
								className={classNames(classes["label"], {
									[classes["active"]!]: props.currentTab === subTab.tab,
								})}>
								{subTab.label}
							</Typography>
						</span>
					))}
				</div>
			)}
		</div>
	);
}
